// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#layout--default .v-toolbar__content{padding-right:5px;padding-left:5px}.searchBlur .app-bar-search{flex:0;min-width:60px}.searchBlur .app-bar-search .v-input__slot,.searchBlur .app-bar-search input{width:0}.searchBlur .app-bar-search .v-input__slot:before{opacity:0}.app-bar-search .v-icon{margin-top:0!important}", ""]);
// Exports
module.exports = exports;
